/**
 * MLD-3014
 */
import DeviceSession from '../../pages/device-sessions/DeviceSession';
import ShowDeviceSession from '../../pages/device-sessions/ShowDeviceSession';
import DeviceSessions from '../../pages/device-sessions/DeviceSessions';

function getRoutes(routePrefix, layout) {
  const basePath = routePrefix === 'library'
    ? '/v2/app/content/device-sessions'
    : '/v2/mobile/device-sessions';

  return [
    {
      path: basePath,
      name: `${routePrefix}.device_sessions`,
      component: DeviceSessions,
      meta: {
        layout: layout,
        title: `Device Sessions`,
        allow_restricted_user: false,
      },
    },
    {
      path: `${basePath}/:sessionID(\\d+)`,
      component: DeviceSession,
      children: [
        {
          path: ``,
          name: `${routePrefix}.device_session.show`,
          component: ShowDeviceSession,
          meta: {
            layout: layout,
            title: `Device Session`,
            allow_restricted_user: false,
          }
        }
      ]
    }
  ];
}

export default [
  ...getRoutes('library', 'content'),
  ...getRoutes('mobile', 'mobile'),
]
